import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import {
    Card
} from 'antd';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        
        return (
            <div className={css['edit']}>
                <Card title={<span className={css.companyMouName}>公司资料</span>} bordered={false}>
                    <Card title={<span className={css.companyDetailName}><img className={css.img} src={require('./img/companyIcon.png')}/>{`${this.modulesState.companyDetail.name}`}</span>} bordered={false}>
                        <div className={css.row}>
                            <div className={css.rowCol}>
                                <div className={css.colName}>纳税人识别号</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.taxId}</div>
                            </div>
                            <div className={css.rowCol}>
                                <div className={css.colName}>公司联系人</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.contactName}</div>
                            </div>
                        </div>
                        <div className={css.row}>
                            <div className={css.rowCol}>
                                <div className={css.colName}>邮箱地址</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.email}</div>
                            </div>
                            <div className={css.rowCol}>
                                <div className={css.colName}>联系电话</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.phone}</div>
                            </div>
                        </div>
                        <div className={css.row}>
                            <div className={css.rowCol}>
                                <div className={css.colName}>所在国家或地区</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.country}</div>
                            </div>
                            <div className={css.rowCol}>
                                <div className={css.colName}>所在城市</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.city}</div>
                            </div>
                        </div>
                        <div className={css.row}>
                            <div className={css.rowCol}>
                                <div className={css.colName}>详细地址</div>
                                <div className={css.colDetail}>{this.modulesState.companyDetail.address}</div>
                            </div>
                            <div className={css.rowCol}>
                                <div className={css.colName}></div>
                                <div className={css.colDetail}></div>
                            </div>
                        </div>
                    </Card>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/GroupInfo/UI.Edit.tsx